<template>
  <div class="wrapper-check-availability--header">
    <div class="wrapper-header-top">
      <div class="wrapper-experience-name">
        <h2>{{ experience.name }}</h2>
        <p>{{ $t(`${base}.from`, { location: experience.starting_point }) }}</p>
      </div>
      <div class="wrapper-select-month">
        <el-select
          v-model="value"
          class="availability-select"
          @change="handleChange"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </div>
    <!-- <div class="wrapper-header-bottom">
      <div class="check-availability-item-left">
        <p class="check-title">{{ $t(`${base}.dates`) }}</p>
        <p class="check-subtitle"
          ><span>{{ $t(`${base}.start`) }}</span
          ><span>{{ $t(`${base}.end`) }}</span></p
        >
      </div>
      <div class="check-availability-item-right">
        <p class="check-title">{{ $t(`${base}.price`) }}</p>
        <p class="check-subtitle">&nbsp;</p>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadAvailabilityHeader',
  props: {
    experience: { type: Object, required: true },
  },
  data() {
    return {
      base: 'experience.availability.modal.header',
      value: null,
    }
  },
  computed: {
    ...mapState('availability', {
      availabilityRanges: (state) => state.availability.ranges,
    }),
    current() {
      return this.availabilityRanges.find((range) => range.current)
    },
    options() {
      const options = this.availabilityRanges.reduce((list, i) => {
        i.items.forEach((item) => {
          list = list.concat([{ label: item.name, value: item.id }])
        })

        return list
      }, [])

      return options
    },
  },
  watch: {
    current: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.value = newValue && newValue.items.length ? newValue.item : null
      },
    },
    async options(newValue, oldValue) {
      if (oldValue.length === 0 && newValue.length > 0) {
        await this.$store.dispatch('availability/setCurrent', {
          id: newValue[0].value,
        })
      }
    },
  },
  methods: {
    async handleChange(value) {
      await this.$store.dispatch('availability/setCurrent', { id: value })
    },
  },
}
</script>

<style lang="scss">
.wrapper-check-availability--header {
  .wrapper-header-top {
    padding: 1em;
    display: grid;
    grid-template-columns: 1.2fr 0.8fr;
    text-align: right;

    .availability-select {
      input {
        border: 0;
        font-size: 2.5em;
        font-weight: 600;
        line-height: 1;
        height: auto;
        text-align: right;
        padding-left: 0;
      }

      .el-select__caret {
        font-size: 2em;
        margin-top: -5px;
        margin-right: -10px;

        &.is-reverse {
          margin-top: 0;
          margin-right: -5px;
        }
      }

      @media screen and (max-width: 400px) {
        input {
          font-size: 2em;
        }
        .el-select__caret {
          font-size: 1em;
          margin: 0;

          &.is-reverse {
            margin: 0;
          }
        }
      }
    }

    @media screen and (max-width: 900px) {
      border-bottom: 1px solid #ebeef2;
    }

    @media screen and (max-width: 400px) {
      .wrapper-header-top {
        .availability-select {
          input {
            font-size: 2em;
          }

          .el-select__caret {
            font-size: 1em;
            margin: 0;

            &.is-reverse {
              margin: 0;
            }
          }
        }
      }
    }

    @media screen and (max-width: 420px) {
      .availability-select {
        input {
          font-size: 2.7em;
        }
      }
    }

    @media screen and (max-width: 340px) {
      padding-right: 0;

      .availability-select {
        input {
          font-size: 2em;
        }
      }
    }
  }
  .wrapper-experience-name {
    text-align: left;
    color: #606266;
    font-size: 0.8em;

    h2 {
      margin: 10px 0;
    }
  }

  @media screen and (max-width: 900px) {
    .wrapper-header-top {
      grid-template-columns: 1fr;
    }
    .wrapper-experience-name {
      display: none;
    }
  }
  .wrapper-header-bottom {
    background-color: #f9f9f9;
    border-top: 1px solid #ebeef2;
    display: grid;
    grid-template-columns: auto 1fr;

    .check-title {
      font-weight: 700;
    }
    .check-subtitle {
      font-style: italic;
    }

    .check-availability-item-left {
      width: 215px;

      .check-subtitle {
        display: grid;
        grid-template-columns: 1fr 1fr;

        span:last-child {
          text-align: right;
        }
      }
    }

    .check-availability-item-left,
    .check-availability-item-right {
      padding: 10px 15px 15px;
    }

    @media screen and (max-width: 900px) {
      display: none;
    }
  }
}
</style>
